export default __webpack_public_path__ + "be1916bd49102ddde237ee78e831d57c.png";